module.exports = __webpack_public_path__ + "static/media/Figma-logo.bfc8530d.svg";